import { COOKIE_SETTINGS_TTL } from "./constants";

export const getDaysAsMS = (days: number) => days * 24 * 60 * 60 * 1000;
export const getNewDateDaysFromNow = (days: number) =>
  new Date(new Date().getTime() + getDaysAsMS(days));
export const getDefaultNewCookieExpiration = () =>
  getNewDateDaysFromNow(COOKIE_SETTINGS_TTL);
